import { Link } from "react-router-dom";
import ChevronDown from '../../../assets/ChevronDown';
import './NavLink.css'

export default function NavLink({ text = '', to = '/', withMenu, onClick, children, ...others }) {

   return (
      !withMenu ? <Link className="navLink" to={to} >{text}</Link>
         :
         <>
            <li onClick={onClick ?? null} className='mega-menu-chevron-group' {...others}>
               <div className='mega-menu-chevron-row'>
                  <span className="navLink">{text}</span>
                  < ChevronDown />
               </div>
               {children}
            </li>

         </>
   )
}